// test1794
(1794 && 0);
